import React, { useEffect, useState } from "react";
import { getData } from "../utils/api";
import { useAuth } from "../context/AuthContext";
import { FiUser } from "react-icons/fi";

const Profile = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { logout } = useAuth();

  useEffect(() => {
    const fetchProfile = async () => {
      setLoading(true);
      setError(null);
      try {
        const result = await getData("/entity/admin/auth");
        if (result.status && result.data) {
          setProfile(result.data);
        } else {
          setError("Invalid response");
        }
      } catch (err) {
        setError(err.message || "Error fetching profile");
      } finally {
        setLoading(false);
      }
    };
    fetchProfile();
  }, []);

  const formatTimestamp = (ts) => {
    if (!ts) return "-";
    const date = new Date(ts * 1000);
    return date.toLocaleString();
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (error) {
    return <div className="text-red-500 text-center mt-8">{error}</div>;
  }

  return (
    <div className="max-w-md mx-auto bg-white rounded-lg shadow p-8 mt-8 flex flex-col items-center">
      {/* Profile Icon */}
      <div className="w-24 h-24 rounded-full bg-blue-100 flex items-center justify-center mb-6">
        <FiUser className="w-16 h-16 text-blue-400" />
      </div>
      <h1 className="text-2xl font-bold mb-6">Profile</h1>
      <div className="space-y-4 w-full">
        <div>
          <span className="font-semibold">Name:</span> {profile?.name}
        </div>
        <div>
          <span className="font-semibold">ID:</span> {profile?.id}
        </div>
        <div>
          <span className="font-semibold">Issued At:</span>{" "}
          {formatTimestamp(profile?.iat)}
        </div>
        <div>
          <span className="font-semibold">Expires At:</span>{" "}
          {formatTimestamp(profile?.exp)}
        </div>
      </div>
      <button className="btn btn-error mt-8 w-full text-white" onClick={logout}>
        Logout
      </button>
    </div>
  );
};

export default Profile;
